module.exports = __webpack_public_path__ + "img/copy.3a4993a6.svg";